import { postOrThrow } from '../utils/ApiUtil';
import { getMock } from '../utils/mockRegistry';
import { mock } from '../common/mockFlag';
import { globalStore } from '../GlobalStore';
import { CommentAE } from '../common/model';
import type { Demand, DemandAddEditParam } from './model';
import type {
  AddDemandCommentRequestDTO,
  AddDemandRequestDTO,
  DemandDTO,
  EditDemandRequestDTO,
} from './DemandType';

const resolveUserName = (userId?: string): string => {
  if (!userId) {
    return '';
  }
  return globalStore.userMap.get(userId)?.userName || '';
};

const toDemand = (dto: DemandDTO): Demand => ({
  id: dto.id,
  content: dto.demandName || '',
  submitterId: dto.fromUserId || '',
  submitterName: resolveUserName(dto.fromUserId),
  executorId: dto.fromUserId || '',
  executorName: resolveUserName(dto.fromUserId),
  submitTime: dto.demandDate || new Date(),
  status: dto.demandStatus ?? 0,
  comments: null,
  logs: null,
});

const toAddRequest = (demand: DemandAddEditParam): AddDemandRequestDTO => ({
  demandName: demand.content,
  demandDate: new Date(),
  demandStatus: demand.status,
});

const toEditRequest = (demand: DemandAddEditParam): EditDemandRequestDTO => ({
  id: String(demand.id),
  demandName: demand.content,
  demandStatus: demand.status,
});

export const DemandApi = {
  async getDemandListData(): Promise<Demand[]> {
    if (mock && false) {
      return getMock('demandList') as Demand[];
    }
    const list = await postOrThrow<string, DemandDTO[]>('/sparrow/demand/queryDemandList', '');
    return (list || []).map(toDemand);
  },

  async addOrEditDemand(demand: DemandAddEditParam): Promise<number> {
    if (mock && false) {
      return 0;
    }
    if (demand.id != null && demand.id !== '') {
      await postOrThrow<EditDemandRequestDTO, boolean>('/sparrow/demand/editDemand', toEditRequest(demand));
      return 0;
    }
    const demandId = await postOrThrow<AddDemandRequestDTO, string>(
      '/sparrow/demand/addDemand',
      toAddRequest(demand),
    );
    return demandId as unknown as number;
  },

  async addOrEditComment(comment: CommentAE): Promise<number> {
    if (mock && false) {
      return 0;
    }
    const param: AddDemandCommentRequestDTO = {
      targetId: comment.targetId ? String(comment.targetId) : '',
      targetType: 'demand',
      content: comment.content,
      replyToId: comment.replyToId ? String(comment.replyToId) : undefined,
    };
    await postOrThrow<AddDemandCommentRequestDTO, unknown>('/sparrow/demand/addComment', param);
    return 0;
  },

  async deleteDemand(id: string | number): Promise<boolean> {
    if (mock && false) {
      return true;
    }
    return postOrThrow<string, boolean>('/sparrow/demand/deleteDemand', String(id));
  },
};

/** @deprecated use DemandApi */
export const demandApi = {
  getDemandListData: () => DemandApi.getDemandListData(),
  addOrEditDemand: (d: DemandAddEditParam) => DemandApi.addOrEditDemand(d),
  addOrEditComment: (c: CommentAE) => DemandApi.addOrEditComment(c),
  deleteDemand: (id: string | number) => DemandApi.deleteDemand(id),
};
